import { useState, useEffect, useMemo } from 'react';
import { createLocalStorageSync } from '../components/utilities/functions';

export const useCartHeader = () => {
	const cartSync = useMemo(() => createLocalStorageSync('cartSession'), []);

	const [cart, setCart] = useState(() => cartSync.get());

	useEffect(() => {
		const unsubscribe = cartSync.subscribe(setCart);

		const handleStorage = (event) => {
			if (event.key === 'cartSession') {
				setCart(event.newValue ? JSON.parse(event.newValue) : null);
			}
		};
		window.addEventListener('storage', handleStorage);

		return () => {
			unsubscribe();
			window.removeEventListener('storage', handleStorage);
		};
	}, [cartSync]);

	return { cart, setCart };
};
